import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@mui/material/styles';

/**
 * Styles for TypeOfProductModal component
 * Uses Material UI theme tokens for consistent design system integration
 */
export const useTypeOfProductModalStyles = makeStyles((theme: Theme) => ({
  contentModal: {
    padding: `${theme.spacing(5)} !important`,
  },
  subtitle: {
    color: theme.palette.text.primary,
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
    marginBottom: theme.spacing(2),
    maxWidth: theme.spacing(50),
    justifyContent: 'space-between',
  },
  title: {
    color: theme.palette.text.primary,
    fontSize: theme.typography.h5.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
    textAlign: 'center',
  },
  subTitle: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.body1.fontSize,
    lineHeight: theme.typography.body1.lineHeight,
    textAlign: 'center',
    marginBottom: 0,
    '& strong': {
      fontWeight: theme.typography.fontWeightMedium,
    },
    whiteSpace: 'break-spaces',
  },
  description: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.body1.fontSize,
    lineHeight: theme.typography.body1.lineHeight,
    textAlign: 'center',
    marginBottom: theme.spacing(2),
    '& strong': {
      fontWeight: theme.typography.fontWeightMedium,
    },
    whiteSpace: 'break-spaces',
  },
  hideItem: {
    visibility: 'hidden',
    height: 0,
    padding: 0,
  },
  selectContainer: {
    marginTop: theme.spacing(4),
  },
}));
